import API from "./API";

export default class AssetComponentAPI extends API {
  constructor(parameters = {}) {
    super("/AssetComponent", parameters);
  }

}
